import React from 'react';
import { Star, Check, BookOpen, ShieldCheck } from 'lucide-react';
export function ProductInfo() {
  return <div className="flex flex-col space-y-8" data-id="element-92">
      <div data-id="element-93">
        <div className="flex items-center space-x-3 mb-4" data-id="element-94">
          <div className="flex text-gold" data-id="element-95">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-96" />)}
          </div>
          <span className="text-xs tracking-widest uppercase text-ink/60" data-id="element-97">
            4.9/5 • Leído por miles
          </span>
        </div>

        <h1 className="text-4xl sm:text-5xl font-serif text-ink mb-4 leading-tight" data-id="element-98">
          Péptidos, GLP-1 y Pérdida de Peso
        </h1>

        <div className="flex items-center space-x-4 mb-6" data-id="element-99">
          <span className="text-3xl font-serif text-ink" data-id="element-100">US$7.99</span>
          <span className="text-xl font-serif text-ink/40 line-through" data-id="element-101">
            US$20
          </span>
          <span className="bg-gold/10 text-gold border border-gold/20 px-3 py-1 text-xs tracking-widest uppercase font-medium" data-id="element-102">
            Ahorras US$12
          </span>
        </div>

        <p className="text-lg text-ink/80 mb-6 leading-relaxed font-light" data-id="element-103">
          La guía educativa que te ayudará a comprender cómo funciona realmente
          el manejo moderno del peso.
        </p>

        <div className="h-px w-full bg-gradient-to-r from-gold/0 via-gold/30 to-gold/0 mb-6" data-id="element-104"></div>

        <p className="text-ink/70 mb-8 leading-relaxed font-light" data-id="element-105">
          Aquí no encontrarás promesas milagrosas. Encontrarás conocimiento.
          Porque cuando entiendes cómo funciona tu cuerpo, puedes tomar
          decisiones mucho más informadas sobre tu salud.
        </p>
      </div>

      <div className="space-y-5" data-id="element-106">
        <h3 className="text-xs tracking-[0.15em] uppercase text-gold font-medium" data-id="element-107">
          Dentro descubrirás:
        </h3>
        <ul className="space-y-4" data-id="element-108">
          {['Por qué el peso corporal no depende únicamente de las calorías o la fuerza de voluntad.', 'Qué son realmente los péptidos y cuál es su papel dentro de la medicina moderna.', 'Cómo actúan los tratamientos basados en GLP-1 y qué ocurre dentro del organismo.', 'Las diferencias entre los principales medicamentos disponibles.', 'Qué beneficios potenciales ha observado la evidencia científica.', 'Los posibles efectos secundarios y cómo comprenderlos mejor.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-109">
              <Check className="w-5 h-5 text-gold mr-4 flex-shrink-0 stroke-[1.5]" data-id="element-110" />
              <span className="text-ink/80 text-sm leading-relaxed font-light" data-id="element-111">
                {item}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="pt-8" data-id="element-112">
        <a href="https://newdigitalguide.com/products/peptidos-glp-1-y-perdida-de-peso-guia-educativa" className="block w-full text-center bg-ink text-white tracking-[0.2em] uppercase text-sm py-5 px-8 hover:bg-ink-light transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 border border-ink" data-id="element-113">
          Acceder Ahora
        </a>
        <p className="text-center text-xs tracking-widest uppercase text-ink/50 mt-5 flex items-center justify-center" data-id="element-114">
          <ShieldCheck className="w-4 h-4 mr-2 stroke-[1.5]" data-id="element-115" /> Acceso inmediato
          y seguro
        </p>
      </div>

      <div className="bg-white p-6 border border-gold/20 mt-8 shadow-sm" data-id="element-116">
        <h4 className="text-xs tracking-[0.15em] uppercase text-ink mb-3 flex items-center font-medium" data-id="element-117">
          <BookOpen className="w-4 h-4 mr-3 text-gold stroke-[1.5]" data-id="element-118" />
          Formato Digital
        </h4>
        <p className="text-sm text-ink/70 leading-relaxed font-light" data-id="element-119">
          Recibirás acceso instantáneo a la guía en formato PDF, compatible con
          cualquier dispositivo (celular, tablet o computadora) inmediatamente
          después de tu compra.
        </p>
      </div>
    </div>;
}